export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <line
        x1="20.3493"
        y1="3.35026"
        x2="3.37872"
        y2="20.3208"
        stroke="#212121"
        stroke-width="1.8"
      />
      <line
        x1="3.38054"
        y1="3.6202"
        x2="20.3511"
        y2="20.5908"
        stroke="#212121"
        stroke-width="1.8"
      />
    </svg>
  );
};

export const InfoSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8.499 8C8.499 7.86739 8.44632 7.74021 8.35255 7.64645C8.25879 7.55268 8.13161 7.5 7.999 7.5C7.86639 7.5 7.73921 7.55268 7.64545 7.64645C7.55168 7.74021 7.499 7.86739 7.499 8V11C7.499 11.1326 7.55168 11.2598 7.64545 11.3536C7.73921 11.4473 7.86639 11.5 7.999 11.5C8.13161 11.5 8.25879 11.4473 8.35255 11.3536C8.44632 11.2598 8.499 11.1326 8.499 11V8ZM8.749 6C8.749 6.19878 8.67003 6.38942 8.52948 6.52998C8.38892 6.67054 8.19828 6.7495 7.9995 6.7495C7.80072 6.7495 7.61008 6.67054 7.46952 6.52998C7.32896 6.38942 7.25 6.19878 7.25 6C7.25 5.80135 7.32891 5.61084 7.46938 5.47038C7.60984 5.32991 7.80035 5.251 7.999 5.251C8.19765 5.251 8.38816 5.32991 8.52862 5.47038C8.66909 5.61084 8.749 5.80135 8.749 6ZM8 1.5C6.14348 1.5 4.36301 2.2375 3.05025 3.55025C1.7375 4.86301 1 6.64348 1 8.5C1 10.3565 1.7375 12.137 3.05025 13.4497C4.36301 14.7625 6.14348 15.5 8 15.5C9.85652 15.5 11.637 14.7625 12.9497 13.4497C14.2625 12.137 15 10.3565 15 8.5C15 6.64348 14.2625 4.86301 12.9497 3.55025C11.637 2.2375 9.85652 1.5 8 1.5ZM2 8.5C2 7.71207 2.15519 6.93185 2.45672 6.2039C2.75825 5.47595 3.20021 4.81451 3.75736 4.25736C4.31451 3.70021 4.97595 3.25825 5.7039 2.95672C6.43185 2.65519 7.21207 2.5 8 2.5C8.78793 2.5 9.56815 2.65519 10.2961 2.95672C11.0241 3.25825 11.6855 3.70021 12.2426 4.25736C12.7998 4.81451 13.2417 5.47595 13.5433 6.2039C13.8448 6.93185 14 7.71207 14 8.5C14 10.0913 13.3679 11.6174 12.2426 12.7426C11.1174 13.8679 9.5913 14.5 8 14.5C6.4087 14.5 4.88258 13.8679 3.75736 12.7426C2.63214 11.6174 2 10.0913 2 8.5Z"
        fill="#212121"
      />
    </svg>
  );
};
export const CommentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_2184_56055" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.4517 17.6305C22.435 15.9834 23 14.0577 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C14.062 23 15.9915 22.4326 17.6409 21.4455L22.8478 22.8407L21.4517 17.6305Z"
        />
      </mask>
      <path
        d="M21.4517 17.6305L19.9062 16.7078C19.6568 17.1255 19.5871 17.6264 19.7131 18.0963L21.4517 17.6305ZM17.6409 21.4455L18.1068 19.7068C17.6362 19.5807 17.1346 19.6508 16.7165 19.901L17.6409 21.4455ZM22.8478 22.8407L22.3819 24.5793C23.0031 24.7458 23.6659 24.5682 24.1206 24.1135C24.5753 23.6587 24.7529 22.996 24.5865 22.3748L22.8478 22.8407ZM21.2 12C21.2 13.7239 20.7276 15.3319 19.9062 16.7078L22.9973 18.5531C24.1425 16.6348 24.8 14.3915 24.8 12H21.2ZM12 2.8C17.081 2.8 21.2 6.91898 21.2 12H24.8C24.8 4.93076 19.0692 -0.8 12 -0.8V2.8ZM2.8 12C2.8 6.91898 6.91898 2.8 12 2.8V-0.8C4.93076 -0.8 -0.8 4.93076 -0.8 12H2.8ZM12 21.2C6.91898 21.2 2.8 17.081 2.8 12H-0.8C-0.8 19.0692 4.93076 24.8 12 24.8V21.2ZM16.7165 19.901C15.3387 20.7256 13.7275 21.2 12 21.2V24.8C14.3965 24.8 16.6443 24.1397 18.5653 22.99L16.7165 19.901ZM17.175 23.1842L22.3819 24.5793L23.3137 21.102L18.1068 19.7068L17.175 23.1842ZM24.5865 22.3748L23.1904 17.1646L19.7131 18.0963L21.1091 23.3065L24.5865 22.3748Z"
        fill="black"
        mask="url(#path-1-inside-1_2184_56055)"
      />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4L3 9.31372L10.5 13.5M20 4L14.5 21L10.5 13.5M20 4L10.5 13.5"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GiftIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.35963 12.2988C1.35963 12.8044 1.57574 13.2892 1.96043 13.6466C2.34512 14.0041 2.86687 14.2049 3.41091 14.2049H6.35963C6.39363 14.2049 6.42624 14.1924 6.45028 14.17C6.47432 14.1477 6.48783 14.1174 6.48783 14.0858V8.60584C6.48783 8.57424 6.47432 8.54394 6.45028 8.5216C6.42624 8.49926 6.39363 8.48671 6.35963 8.48671H1.61604C1.54803 8.48671 1.48281 8.51181 1.43473 8.55649C1.38664 8.60117 1.35963 8.66177 1.35963 8.72496V12.2988ZM6.48783 7.41454V4.19805H7.51347V7.41454C7.51347 7.44614 7.52698 7.47644 7.55102 7.49878C7.57507 7.52112 7.60768 7.53367 7.64168 7.53367H12.1289C12.3036 7.53367 12.477 7.50597 12.6417 7.45177C12.9414 7.3529 13.2008 7.17031 13.3844 6.92904C13.5681 6.68777 13.6669 6.39962 13.6673 6.10412V5.6276C13.6673 5.24846 13.5052 4.88485 13.2167 4.61675C12.9282 4.34866 12.5369 4.19805 12.1289 4.19805H10.8295C10.8183 4.19788 10.8074 4.19501 10.7978 4.18972C10.7882 4.18442 10.7803 4.17689 10.7747 4.16786C10.7692 4.15883 10.7664 4.14862 10.7664 4.13825C10.7665 4.12787 10.7694 4.11769 10.775 4.1087C11.0718 3.64317 11.1681 3.09061 11.0448 2.56181C10.9215 2.03302 10.5876 1.56709 10.1101 1.25745C9.63262 0.947806 9.04679 0.817344 8.47011 0.892222C7.89342 0.967099 7.36852 1.24178 7.00065 1.66119C6.63278 1.24178 6.10788 0.967099 5.5312 0.892222C4.95451 0.817344 4.36869 0.947806 3.89118 1.25745C3.41367 1.56709 3.07979 2.03302 2.95648 2.56181C2.83317 3.09061 2.92955 3.64317 3.22629 4.1087C3.23188 4.11769 3.23484 4.12787 3.23488 4.13825C3.23493 4.14862 3.23206 4.15883 3.22655 4.16786C3.22105 4.17689 3.2131 4.18442 3.2035 4.18972C3.19389 4.19501 3.18297 4.19788 3.1718 4.19805H1.87245C1.46442 4.19805 1.07311 4.34866 0.784589 4.61675C0.496072 4.88485 0.333984 5.24846 0.333984 5.6276V6.10412C0.334437 6.39962 0.433248 6.68777 0.61687 6.92904C0.800492 7.17031 1.05993 7.3529 1.35963 7.45177C1.52431 7.50597 1.69774 7.53367 1.87245 7.53367H6.35963C6.39363 7.53367 6.42624 7.52112 6.45028 7.49878C6.47432 7.47644 6.48783 7.44614 6.48783 7.41454ZM7.51347 3.00676C7.51347 2.77114 7.58866 2.54082 7.72954 2.34491C7.87041 2.149 8.07064 1.99631 8.3049 1.90614C8.53917 1.81598 8.79695 1.79239 9.04564 1.83835C9.29433 1.88432 9.52277 1.99778 9.70207 2.16438C9.88137 2.33099 10.0035 2.54326 10.0529 2.77435C10.1024 3.00543 10.077 3.24496 9.97998 3.46264C9.88295 3.68032 9.71863 3.86638 9.50779 3.99728C9.29696 4.12818 9.04909 4.19805 8.79552 4.19805H7.51347V3.00676ZM5.11411 1.81844C5.28975 1.80674 5.4661 1.82879 5.63217 1.88321C5.79824 1.93763 5.95046 2.02325 6.07934 2.13474C6.20823 2.24623 6.31102 2.3812 6.3813 2.53123C6.45158 2.68126 6.48784 2.84313 6.48783 3.00676V4.19805H5.20578C4.87427 4.19726 4.55598 4.07718 4.3177 3.863C4.07943 3.64883 3.9397 3.35722 3.92784 3.04938C3.91598 2.74153 4.03291 2.44139 4.25409 2.21193C4.47528 1.98248 4.78351 1.84155 5.11411 1.81874V1.81844ZM7.64168 14.2049H10.5904C11.1344 14.2049 11.6562 14.0041 12.0409 13.6466C12.4256 13.2892 12.6417 12.8044 12.6417 12.2988V8.72496C12.6417 8.66177 12.6147 8.60117 12.5666 8.55649C12.5185 8.51181 12.4533 8.48671 12.3853 8.48671H7.64168C7.60768 8.48671 7.57507 8.49926 7.55102 8.5216C7.52698 8.54394 7.51347 8.57424 7.51347 8.60584V14.0858C7.51347 14.1174 7.52698 14.1477 7.55102 14.17C7.57507 14.1924 7.60768 14.2049 7.64168 14.2049Z"
        fill="white"
      />
    </svg>
  );
};

interface EditIconProps {
  color?: string;
  width?: string;
  height?: string;
}

export const EditIcon: React.FC<EditIconProps> = ({ color, width, height }) => {
  return (
    <svg
      width={width ? width : "16"}
      height={height ? height : "16"}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {width && height ? (
        <path
          d="M15.2299 4.82024C15.4894 4.56076 15.7974 4.35492 16.1364 4.21448C16.4754 4.07403 16.8387 4.00174 17.2056 4.00171C17.5726 4.00168 17.9359 4.07393 18.2749 4.21432C18.6139 4.35472 18.922 4.56051 19.1815 4.81996C19.4409 5.0794 19.6468 5.38741 19.7872 5.72641C19.9277 6.0654 20 6.42873 20 6.79567C20 7.1626 19.9278 7.52595 19.7874 7.86496C19.647 8.20398 19.4412 8.51202 19.1818 8.7715L18.6663 9.28641L14.715 5.33515L15.2299 4.82024ZM13.9069 6.14381L5.34721 14.7047C5.05901 14.9927 4.86016 15.3578 4.77458 15.7562L4.01279 19.3109C3.9927 19.4042 3.99632 19.5011 4.02333 19.5927C4.05034 19.6843 4.09986 19.7677 4.16738 19.8352C4.23491 19.9027 4.31827 19.9522 4.40987 19.9792C4.50146 20.0062 4.59836 20.0099 4.69172 19.9898L8.24636 19.228C8.64472 19.1424 9.00988 18.9436 9.2979 18.6554L17.8588 10.0945L13.9069 6.14381Z"
          fill={color ? color : "#9E9E9E"}
        />
      ) : (
        <path
          id="Vector"
          d="M11.2299 0.820243C11.4894 0.560762 11.7974 0.354923 12.1364 0.214479C12.4754 0.0740348 12.8387 0.00173553 13.2056 0.00170899C13.5726 0.00168245 13.9359 0.0739292 14.2749 0.214325C14.6139 0.35472 14.922 0.560514 15.1815 0.819957C15.4409 1.0794 15.6468 1.38741 15.7872 1.72641C15.9277 2.0654 16 2.42873 16 2.79567C16 3.1626 15.9278 3.52595 15.7874 3.86496C15.647 4.20398 15.4412 4.51202 15.1818 4.7715L14.6663 5.28641L10.715 1.33515L11.2299 0.820243ZM9.90693 2.14381L1.34721 10.7047C1.05901 10.9927 0.860159 11.3578 0.774581 11.7562L0.0127901 15.3109C-0.00729948 15.4042 -0.00367597 15.5011 0.0233296 15.5927C0.0503351 15.6843 0.0998617 15.7677 0.167385 15.8352C0.234907 15.9027 0.318274 15.9522 0.409867 15.9792C0.501461 16.0062 0.598361 16.0099 0.691716 15.9898L4.24636 15.228C4.64472 15.1424 5.00988 14.9436 5.2979 14.6554L13.8588 6.09449L9.90693 2.14381Z"
          fill={color ? color : "#9E9E9E"}
        />
      )}
    </svg>
  );
};

interface DeleteIconProps {
  color?: string;
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.7 18.3H14C13.5 18.3 13.2 17.9 13.2 17.5V10.3H13.9C14.4 10.3 14.7 10.7 14.7 11.1V18.3Z"
        fill={color ? color : "#B71C1C"}
      />
      <path
        d="M10.7 18.3H9.99998C9.49998 18.3 9.19998 17.9 9.19998 17.5V10.3H9.89998C10.4 10.3 10.7 10.7 10.7 11.1V18.3Z"
        fill={color ? color : "#B71C1C"}
      />
      <path
        d="M15.1 5H8V4.3C8 3.9 8.3 3.5 8.8 3.5H16V4.2C16 4.6 15.6 5 15.1 5Z"
        fill={color ? color : "#B71C1C"}
      />
      <path
        d="M22 8H2.8C2.4 8 2 7.6 2 7.1V6.5H21.2C21.6 6.5 22 6.8 22 7.3V8Z"
        fill={color ? color : "#B71C1C"}
      />
      <path
        d="M18 8V20H6V8H18ZM19.5 6.5H4.5V20C4.5 20.8 5.1 21.5 6 21.5H18C18.8 21.5 19.5 20.8 19.5 20V6.5Z"
        fill={color ? color : "#B71C1C"}
      />
    </svg>
  );
};

export const IconMoreVert = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="15"
      viewBox="0 0 4 15"
      fill="none"
    >
      <circle
        cx="2"
        cy="13"
        r="1.5"
        transform="rotate(-90 2 13)"
        fill="#212121"
      />
      <circle
        cx="2"
        cy="7.5"
        r="1.5"
        transform="rotate(-90 2 7.5)"
        fill="#212121"
      />
      <circle
        cx="2"
        cy="2"
        r="1.5"
        transform="rotate(-90 2 2)"
        fill="#212121"
      />
    </svg>
  );
};

export const BackButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 5L0.999938 12.0001L8 19.0001"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.9121 4.48351C14.4725 4.48351 17.3406 7.35164 17.3406 10.9121C17.3406 14.4725 14.4725 17.3406 10.9121 17.3406C7.35164 17.3406 4.48351 14.4725 4.48351 10.9121C4.48351 7.35164 7.35164 4.48351 10.9121 4.48351ZM10.9121 3C6.56043 3 3 6.56043 3 10.9121C3 15.2637 6.56043 18.8241 10.9121 18.8241C15.2637 18.8241 18.8241 15.2637 18.8241 10.9121C18.8241 6.56043 15.2637 3 10.9121 3Z"
        fill="#616161"
      />
      <path
        d="M20.3077 19.3187L15.956 14.967L15.4615 15.4615C15.1648 15.7583 15.1648 16.2528 15.4615 16.6484L19.8132 21L20.3077 20.5055C20.7033 20.2088 20.7033 19.6154 20.3077 19.3187Z"
        fill="#616161"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 6H21M6 12H18M9 18H15"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const FilterOptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 11C11 11.2984 10.8815 11.5845 10.6705 11.7955C10.4595 12.0065 10.1734 12.125 9.875 12.125H3.5C3.20163 12.125 2.91548 12.0065 2.7045 11.7955C2.49353 11.5845 2.375 11.2984 2.375 11C2.375 10.7016 2.49353 10.4155 2.7045 10.2045C2.91548 9.99353 3.20163 9.875 3.5 9.875H9.875C10.1734 9.875 10.4595 9.99353 10.6705 10.2045C10.8815 10.4155 11 10.7016 11 11ZM3.5 6.125H15.875C16.1734 6.125 16.4595 6.00647 16.6705 5.7955C16.8815 5.58452 17 5.29837 17 5C17 4.70163 16.8815 4.41548 16.6705 4.2045C16.4595 3.99353 16.1734 3.875 15.875 3.875H3.5C3.20163 3.875 2.91548 3.99353 2.7045 4.2045C2.49353 4.41548 2.375 4.70163 2.375 5C2.375 5.29837 2.49353 5.58452 2.7045 5.7955C2.91548 6.00647 3.20163 6.125 3.5 6.125ZM8.375 15.875H3.5C3.20163 15.875 2.91548 15.9935 2.7045 16.2045C2.49353 16.4155 2.375 16.7016 2.375 17C2.375 17.2984 2.49353 17.5845 2.7045 17.7955C2.91548 18.0065 3.20163 18.125 3.5 18.125H8.375C8.67337 18.125 8.95952 18.0065 9.1705 17.7955C9.38147 17.5845 9.5 17.2984 9.5 17C9.5 16.7016 9.38147 16.4155 9.1705 16.2045C8.95952 15.9935 8.67337 15.875 8.375 15.875ZM20.7959 13.9541C20.6914 13.8492 20.5672 13.766 20.4305 13.7092C20.2937 13.6524 20.1471 13.6232 19.9991 13.6232C19.851 13.6232 19.7044 13.6524 19.5676 13.7092C19.4309 13.766 19.3067 13.8492 19.2022 13.9541L17.375 15.7812V9.5C17.375 9.20163 17.2565 8.91548 17.0455 8.7045C16.8345 8.49353 16.5484 8.375 16.25 8.375C15.9516 8.375 15.6655 8.49353 15.4545 8.7045C15.2435 8.91548 15.125 9.20163 15.125 9.5V15.7812L13.2959 13.9513C13.0846 13.7399 12.7979 13.6212 12.4991 13.6212C12.2002 13.6212 11.9135 13.7399 11.7022 13.9513C11.4908 14.1626 11.3721 14.4492 11.3721 14.7481C11.3721 15.047 11.4908 15.3337 11.7022 15.545L15.4522 19.295C15.5567 19.3999 15.6809 19.4831 15.8176 19.5399C15.9544 19.5967 16.101 19.6259 16.2491 19.6259C16.3971 19.6259 16.5437 19.5967 16.6805 19.5399C16.8172 19.4831 16.9414 19.3999 17.0459 19.295L20.7959 15.545C21.0069 15.334 21.1254 15.0479 21.1254 14.7495C21.1254 14.4512 21.0069 14.165 20.7959 13.9541Z"
        fill="#212121"
      />
    </svg>
  );
};

export const CoinIcon: React.FC<{ width?: string; height?: string }> = ({
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_3146_8187)">
        <path
          d="M11.9993 23.9999C18.2586 23.9999 23.3327 18.9258 23.3327 12.6666C23.3327 6.40736 18.2586 1.33325 11.9993 1.33325C5.74012 1.33325 0.666016 6.40736 0.666016 12.6666C0.666016 18.9258 5.74012 23.9999 11.9993 23.9999Z"
          fill="#F4900C"
        />
        <path
          d="M11.9993 22.6667C18.2586 22.6667 23.3327 17.5926 23.3327 11.3333C23.3327 5.07411 18.2586 0 11.9993 0C5.74012 0 0.666016 5.07411 0.666016 11.3333C0.666016 17.5926 5.74012 22.6667 11.9993 22.6667Z"
          fill="#FFCC4D"
        />
        <path
          d="M11.9993 21.3334C17.154 21.3334 21.3327 17.1547 21.3327 12.0001C21.3327 6.84542 17.154 2.66675 11.9993 2.66675C6.84469 2.66675 2.66602 6.84542 2.66602 12.0001C2.66602 17.1547 6.84469 21.3334 11.9993 21.3334Z"
          fill="#FFE8B6"
        />
        <path
          d="M11.9993 20.6667C17.154 20.6667 21.3327 16.488 21.3327 11.3333C21.3327 6.17868 17.154 2 11.9993 2C6.84469 2 2.66602 6.17868 2.66602 11.3333C2.66602 16.488 6.84469 20.6667 11.9993 20.6667Z"
          fill="#FFAC33"
        />
        <path
          d="M6.36133 7.2373C6.36133 6.87396 6.71799 6.72863 6.71799 6.72863L11.97 4.26196L17.272 6.72863C17.272 6.72863 17.6373 6.80996 17.6373 7.23996V7.6673H6.36133V7.2373Z"
          fill="#FFE8B6"
        />
        <path
          d="M17.2869 8.55745C17.2869 8.16812 16.9502 7.85278 16.5355 7.85278H7.4202C7.00487 7.85278 6.71554 8.16812 6.71554 8.55745C6.71554 8.82212 6.85154 9.05012 7.0682 9.17078V9.61478H8.47754V9.26212H9.88687V9.61478H11.2962V9.26212H12.7055V9.61478H14.1149V9.26212H15.5242V9.61478H16.9342V9.15278C17.1455 9.02745 17.2869 8.80812 17.2869 8.55745ZM18.3435 16.0001C18.3435 16.1403 18.2878 16.2748 18.1887 16.3739C18.0896 16.4731 17.9551 16.5288 17.8149 16.5288H6.18687C6.04666 16.5288 5.91219 16.4731 5.81305 16.3739C5.7139 16.2748 5.6582 16.1403 5.6582 16.0001C5.6582 15.8599 5.7139 15.7254 5.81305 15.6263C5.91219 15.5271 6.04666 15.4715 6.18687 15.4715H17.8155C18.1069 15.4715 18.3435 15.7081 18.3435 16.0001Z"
          fill="#F4900C"
        />
        <path
          d="M17.6385 8.13343C17.6385 8.22696 17.6013 8.31666 17.5352 8.3828C17.469 8.44894 17.3793 8.4861 17.2858 8.4861H6.71445C6.62467 8.48057 6.54037 8.44101 6.47875 8.37548C6.41712 8.30995 6.38281 8.22338 6.38281 8.13343C6.38281 8.04347 6.41712 7.95691 6.47875 7.89138C6.54037 7.82584 6.62467 7.78628 6.71445 7.78076L17.2858 7.78276C17.332 7.78259 17.3778 7.79152 17.4205 7.80906C17.4632 7.82659 17.5021 7.85239 17.5348 7.88496C17.5676 7.91753 17.5936 7.95624 17.6114 7.99888C17.6292 8.04151 17.6384 8.08723 17.6385 8.13343ZM8.12445 8.54276H15.8771V9.33343H8.12445V8.54276Z"
          fill="#F4900C"
        />
        <path
          d="M8.47641 13.886C8.47641 14.2753 8.26574 14.5906 8.00641 14.5906H7.53641C7.27707 14.5906 7.06641 14.2753 7.06641 13.886V8.54329C7.06641 8.15396 7.27707 7.83862 7.53641 7.83862H8.00641C8.26574 7.83862 8.47641 8.15396 8.47641 8.54329V13.886ZM16.9337 13.886C16.9337 14.2753 16.7237 14.5906 16.4637 14.5906H15.9937C15.7344 14.5906 15.5237 14.2753 15.5237 13.886V8.54329C15.5237 8.15396 15.7337 7.83862 15.9937 7.83862H16.4637C16.7231 7.83862 16.9337 8.15396 16.9337 8.54329V13.886ZM11.2957 13.886C11.2957 14.2753 11.0851 14.5906 10.8257 14.5906H10.3557C10.0964 14.5906 9.88574 14.2753 9.88574 13.886V8.54329C9.88574 8.15396 10.0964 7.83862 10.3557 7.83862H10.8257C11.0851 7.83862 11.2957 8.15396 11.2957 8.54329V13.886ZM14.1144 13.886C14.1144 14.2753 13.9037 14.5906 13.6444 14.5906H13.1751C12.9157 14.5906 12.7051 14.2753 12.7051 13.886V8.54329C12.7051 8.15396 12.9157 7.83862 13.1751 7.83862H13.6444C13.9037 7.83862 14.1144 8.15396 14.1144 8.54329V13.886Z"
          fill="#FFD983"
        />
        <path
          d="M17.2862 14.2381C17.2862 14.6274 16.9708 14.9428 16.5815 14.9428H7.41951C7.23262 14.9428 7.05339 14.8685 6.92124 14.7364C6.78909 14.6042 6.71484 14.425 6.71484 14.2381C6.71484 14.0512 6.78909 13.872 6.92124 13.7398C7.05339 13.6077 7.23262 13.5334 7.41951 13.5334H16.5815C16.9702 13.5334 17.2862 13.8488 17.2862 14.2381Z"
          fill="#FFCC4D"
        />
        <path
          d="M17.9911 14.9427C17.9911 15.332 17.6758 15.6474 17.2864 15.6474H6.71443C6.52754 15.6474 6.34831 15.5731 6.21616 15.441C6.08401 15.3088 6.00977 15.1296 6.00977 14.9427C6.00977 14.7558 6.08401 14.5766 6.21616 14.4444C6.34831 14.3123 6.52754 14.238 6.71443 14.238H17.2858C17.6751 14.238 17.9911 14.5534 17.9911 14.9427Z"
          fill="#FFD983"
        />
        <path
          d="M18.3435 15.4713C18.3435 15.6115 18.2878 15.746 18.1887 15.8451C18.0896 15.9443 17.9551 16 17.8149 16H6.18687C6.11744 16 6.0487 15.9863 5.98456 15.9597C5.92042 15.9332 5.86214 15.8942 5.81305 15.8451C5.76395 15.796 5.72501 15.7377 5.69845 15.6736C5.67188 15.6095 5.6582 15.5407 5.6582 15.4713C5.6582 15.4019 5.67188 15.3331 5.69845 15.269C5.72501 15.2048 5.76395 15.1466 5.81305 15.0975C5.86214 15.0484 5.92042 15.0094 5.98456 14.9829C6.0487 14.9563 6.11744 14.9426 6.18687 14.9426H17.8155C18.1069 14.9426 18.3435 15.1793 18.3435 15.4713Z"
          fill="#FFD983"
        />
        <path
          d="M17.2862 8.19075C17.2862 7.80142 16.9495 7.48608 16.5348 7.48608H7.41951C7.00418 7.48608 6.71484 7.80142 6.71484 8.19075C6.71484 8.45542 6.85084 8.68342 7.06751 8.80408V9.24808H8.47684V8.89542H9.88618V9.24808H11.2955V8.89542H12.7048V9.24808H14.1142V8.89542H15.5235V9.24808H16.9335V8.78608C17.1448 8.66075 17.2862 8.44142 17.2862 8.19075Z"
          fill="#FFCC4D"
        />
        <path
          d="M6.36133 7.64208C6.36133 7.27875 6.71799 7.13341 6.71799 7.13341L11.97 4.66675L17.272 7.13341C17.272 7.13341 17.6373 7.21475 17.6373 7.64475V7.83875H6.36133V7.64208Z"
          fill="#FFD983"
        />
        <path
          d="M12 5.56201C12 5.56201 8.36333 7.27601 8.00066 7.43068C7.63733 7.58468 7.75866 7.83801 8.00133 7.83801H15.9813C16.356 7.83801 16.2673 7.55201 15.97 7.39734C15.6727 7.24334 12 5.56201 12 5.56201Z"
          fill="#FFAC33"
        />
        <path
          d="M17.6385 7.83802C17.6385 7.93155 17.6013 8.02125 17.5352 8.08739C17.469 8.15353 17.3793 8.19069 17.2858 8.19069H6.71445C6.62467 8.18516 6.54037 8.1456 6.47875 8.08007C6.41712 8.01454 6.38281 7.92797 6.38281 7.83802C6.38281 7.74806 6.41712 7.6615 6.47875 7.59597C6.54037 7.53043 6.62467 7.49087 6.71445 7.48535L17.2858 7.48735C17.332 7.48718 17.3778 7.49611 17.4205 7.51365C17.4632 7.53118 17.5021 7.55698 17.5348 7.58955C17.5676 7.62212 17.5936 7.66083 17.6114 7.70347C17.6292 7.7461 17.6384 7.79182 17.6385 7.83802Z"
          fill="#FFD983"
        />
      </g>
      <defs>
        <clipPath id="clip0_3146_8187">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

interface DeleteNewIconProps {
  color?: string;
}

export const DeleteNewIcon: React.FC<DeleteNewIconProps> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10 6H14C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6ZM8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6H21C21.2652 6 21.5196 6.10536 21.7071 6.29289C21.8946 6.48043 22 6.73478 22 7C22 7.26522 21.8946 7.51957 21.7071 7.70711C21.5196 7.89464 21.2652 8 21 8H20.118L19.232 18.34C19.1468 19.3385 18.69 20.2686 17.9519 20.9463C17.2137 21.6241 16.2481 22.0001 15.246 22H8.754C7.75191 22.0001 6.78628 21.6241 6.04815 20.9463C5.31002 20.2686 4.85318 19.3385 4.768 18.34L3.882 8H3C2.73478 8 2.48043 7.89464 2.29289 7.70711C2.10536 7.51957 2 7.26522 2 7C2 6.73478 2.10536 6.48043 2.29289 6.29289C2.48043 6.10536 2.73478 6 3 6H8ZM15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11C13.7348 11 13.4804 11.1054 13.2929 11.2929C13.1054 11.4804 13 11.7348 13 12V16C13 16.2652 13.1054 16.5196 13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16V12ZM10 11C10.2652 11 10.5196 11.1054 10.7071 11.2929C10.8946 11.4804 11 11.7348 11 12V16C11 16.2652 10.8946 16.5196 10.7071 16.7071C10.5196 16.8946 10.2652 17 10 17C9.73478 17 9.48043 16.8946 9.29289 16.7071C9.10536 16.5196 9 16.2652 9 16V12C9 11.7348 9.10536 11.4804 9.29289 11.2929C9.48043 11.1054 9.73478 11 10 11ZM6.76 18.17C6.8026 18.6694 7.03117 19.1346 7.40044 19.4735C7.76972 19.8124 8.25278 20.0003 8.754 20H15.246C15.7469 19.9998 16.2294 19.8117 16.5983 19.4728C16.9671 19.134 17.1954 18.6691 17.238 18.17L18.11 8H5.89L6.76 18.17Z"
        fill={color ? color : "#B71C1C"}
      />
    </svg>
  );
};

interface DeleteIconForTopBarProps {
  color?: string;
}

export const DeleteIconForTopBar: React.FC<DeleteIconForTopBarProps> = ({
  color,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M2.616 16C2.15533 16 1.771 15.846 1.463 15.538C1.155 15.23 1.00067 14.8453 1 14.384V1.99998H0V0.99998H4V0.22998H10V0.99998H14V1.99998H13V14.385C13 14.845 12.846 15.2293 12.538 15.538C12.23 15.8466 11.8453 16.0006 11.384 16H2.616ZM4.808 13H5.808V3.99998H4.808V13ZM8.192 13H9.192V3.99998H8.192V13Z"
        fill={color ? color : "#212121"}
      />
    </svg>
  );
};

export const DollarCaseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.03336 0.166992H7.96403C7.3647 0.166992 6.86537 0.166992 6.46937 0.220326C6.0507 0.276326 5.6727 0.400326 5.36936 0.703659C5.06536 1.00766 4.94136 1.38566 4.88536 1.80366C4.84736 2.08833 4.83603 2.76766 4.83336 3.35033C3.48536 3.39499 2.67536 3.55233 2.11336 4.11499C1.33203 4.89566 1.33203 6.15299 1.33203 8.66699C1.33203 11.181 1.33203 12.4383 2.11336 13.219C2.89403 14.0003 4.15136 14.0003 6.66536 14.0003H9.33203C11.846 14.0003 13.1034 14.0003 13.884 13.219C14.6654 12.4383 14.6654 11.181 14.6654 8.66699C14.6654 6.15299 14.6654 4.89566 13.884 4.11499C13.322 3.55233 12.512 3.39499 11.164 3.35099C11.1614 2.76766 11.1507 2.08833 11.112 1.80433C11.056 1.38566 10.932 1.00766 10.628 0.704325C10.3247 0.400326 9.9467 0.276326 9.52803 0.220326C9.13203 0.166992 8.63203 0.166992 8.03336 0.166992ZM10.164 3.33499C10.1607 2.77033 10.1514 2.16299 10.1214 1.93699C10.0794 1.62966 10.008 1.49766 9.92136 1.41099C9.8347 1.32433 9.7027 1.25299 9.3947 1.21099C9.07336 1.16833 8.64136 1.16699 7.9987 1.16699C7.35603 1.16699 6.92403 1.16833 6.60203 1.21166C6.2947 1.25299 6.1627 1.32433 6.07603 1.41166C5.98936 1.49833 5.91803 1.62966 5.87603 1.93699C5.84603 2.16366 5.83603 2.77033 5.83336 3.33499C6.09403 3.33366 6.37203 3.33366 6.66536 3.33366H9.33203C9.62603 3.33366 9.90337 3.33366 10.164 3.33499ZM7.9987 5.50033C8.13131 5.50033 8.25848 5.553 8.35225 5.64677C8.44602 5.74054 8.4987 5.86772 8.4987 6.00033V6.00699C9.2247 6.18966 9.83203 6.76233 9.83203 7.55566C9.83203 7.68827 9.77935 7.81544 9.68559 7.90921C9.59182 8.00298 9.46464 8.05566 9.33203 8.05566C9.19942 8.05566 9.07225 8.00298 8.97848 7.90921C8.88471 7.81544 8.83203 7.68827 8.83203 7.55566C8.83203 7.29966 8.54803 6.94499 7.9987 6.94499C7.44936 6.94499 7.16536 7.29966 7.16536 7.55566C7.16536 7.81166 7.44936 8.16699 7.9987 8.16699C8.92203 8.16699 9.83203 8.80699 9.83203 9.77833C9.83203 10.5717 9.2247 11.1437 8.4987 11.327V11.3337C8.4987 11.4663 8.44602 11.5934 8.35225 11.6872C8.25848 11.781 8.13131 11.8337 7.9987 11.8337C7.86609 11.8337 7.73891 11.781 7.64514 11.6872C7.55138 11.5934 7.4987 11.4663 7.4987 11.3337V11.327C6.7727 11.1443 6.16536 10.5717 6.16536 9.77833C6.16536 9.64572 6.21804 9.51854 6.31181 9.42477C6.40558 9.331 6.53276 9.27833 6.66536 9.27833C6.79797 9.27833 6.92515 9.331 7.01892 9.42477C7.11269 9.51854 7.16536 9.64572 7.16536 9.77833C7.16536 10.0343 7.44936 10.389 7.9987 10.389C8.54803 10.389 8.83203 10.0343 8.83203 9.77833C8.83203 9.52232 8.54803 9.16699 7.9987 9.16699C7.07536 9.16699 6.16536 8.52699 6.16536 7.55566C6.16536 6.76233 6.7727 6.18966 7.4987 6.00699V6.00033C7.4987 5.86772 7.55138 5.74054 7.64514 5.64677C7.73891 5.553 7.86609 5.50033 7.9987 5.50033Z"
        fill="#F3F3F3"
      />
    </svg>
  );
};

export const VideoIconForPostGrid = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g filter="url(#filter0_d_4091_39633)">
        <path
          d="M2.81446 0.668945H8.11392V2.00028H9.43878V0.668945C9.79004 0.669122 10.1269 0.809676 10.3752 1.05971C10.6235 1.30973 10.763 1.64877 10.763 2.00228V10.0023C10.763 10.3558 10.6235 10.6948 10.3752 10.9449C10.1269 11.1949 9.79004 11.3354 9.43878 11.3356V10.0003H8.11392V11.3356H2.81446V10.0003H1.48959V11.3356C1.13821 11.3356 0.800567 11.1951 0.552106 10.9451C0.303646 10.695 0.164063 10.3559 0.164062 10.0023V2.00228C0.164062 1.64866 0.303646 1.30952 0.552106 1.05947C0.800567 0.809421 1.13755 0.668945 1.48893 0.668945L1.48959 2.00028H2.81446V0.668945ZM4.13866 8.00228L7.11961 6.00228L4.13866 4.00228V8.00228ZM9.43878 8.66694V6.66694H8.11392V8.66694H9.43878ZM9.43878 5.33361V3.33361H8.11392V5.33361H9.43878ZM2.81446 8.66694V6.66694H1.48959V8.66694H2.81446ZM2.81446 5.33361V3.33361H1.48959V5.33361H2.81446Z"
          fill="#F3F3F3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4091_39633"
          x="0.164062"
          y="0.668945"
          width="14.5977"
          height="14.667"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4091_39633"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4091_39633"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const LockIcon: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill={color ? color : "9E9E9E"}
    >
      <path
        d="M12.832 17C13.3625 17 13.8712 16.7893 14.2462 16.4142C14.6213 16.0391 14.832 15.5304 14.832 15C14.832 14.4696 14.6213 13.9609 14.2462 13.5858C13.8712 13.2107 13.3625 13 12.832 13C12.3016 13 11.7929 13.2107 11.4178 13.5858C11.0427 13.9609 10.832 14.4696 10.832 15C10.832 15.5304 11.0427 16.0391 11.4178 16.4142C11.7929 16.7893 12.3016 17 12.832 17ZM18.832 8C19.3625 8 19.8712 8.21071 20.2462 8.58579C20.6213 8.96086 20.832 9.46957 20.832 10V20C20.832 20.5304 20.6213 21.0391 20.2462 21.4142C19.8712 21.7893 19.3625 22 18.832 22H6.83203C6.3016 22 5.79289 21.7893 5.41782 21.4142C5.04274 21.0391 4.83203 20.5304 4.83203 20V10C4.83203 9.46957 5.04274 8.96086 5.41782 8.58579C5.79289 8.21071 6.3016 8 6.83203 8H7.83203V6C7.83203 4.67392 8.35882 3.40215 9.2965 2.46447C10.2342 1.52678 11.5059 1 12.832 1C13.4886 1 14.1388 1.12933 14.7454 1.3806C15.3521 1.63188 15.9033 2.00017 16.3676 2.46447C16.8319 2.92876 17.2002 3.47995 17.4514 4.08658C17.7027 4.69321 17.832 5.34339 17.832 6V8H18.832ZM12.832 3C12.0364 3 11.2733 3.31607 10.7107 3.87868C10.1481 4.44129 9.83203 5.20435 9.83203 6V8H15.832V6C15.832 5.20435 15.516 4.44129 14.9534 3.87868C14.3907 3.31607 13.6277 3 12.832 3Z"
        fill={color ? color : "9E9E9E"}
      />
    </svg>
  );
};

export const CartIcon: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <path
        d="M16.5009 21.0003C16.9429 21.0003 17.3668 20.8247 17.6794 20.5122C17.9919 20.1996 18.1675 19.7757 18.1675 19.3337C18.1675 18.8916 17.9919 18.4677 17.6794 18.1551C17.3668 17.8426 16.9429 17.667 16.5009 17.667C16.0588 17.667 15.6349 17.8426 15.3224 18.1551C15.0098 18.4677 14.8342 18.8916 14.8342 19.3337C14.8342 19.7757 15.0098 20.1996 15.3224 20.5122C15.6349 20.8247 16.0588 21.0003 16.5009 21.0003ZM7.61198 21.0003C8.05401 21.0003 8.47793 20.8247 8.79049 20.5122C9.10305 20.1996 9.27865 19.7757 9.27865 19.3337C9.27865 18.8916 9.10305 18.4677 8.79049 18.1551C8.47793 17.8426 8.05401 17.667 7.61198 17.667C7.16995 17.667 6.74603 17.8426 6.43347 18.1551C6.12091 18.4677 5.94531 18.8916 5.94531 19.3337C5.94531 19.7757 6.12091 20.1996 6.43347 20.5122C6.74603 20.8247 7.16995 21.0003 7.61198 21.0003Z"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.28889 3.66667H19.1933C20.7244 3.66667 21.83 5.07778 21.41 6.49778L19.5722 12.72C19.2889 13.6756 18.3844 14.3333 17.3556 14.3333H7.18C6.15 14.3333 5.24444 13.6744 4.96222 12.72L2.28889 3.66667ZM2.28889 3.66667L1.5 1L2.28889 3.66667Z"
        fill={color ? color : "#9E9E9E"}
      />
      <path
        d="M2.28889 3.66667H19.1933C20.7244 3.66667 21.83 5.07778 21.41 6.49778L19.5722 12.72C19.2889 13.6756 18.3844 14.3333 17.3556 14.3333H7.18C6.15 14.3333 5.24444 13.6744 4.96222 12.72L2.28889 3.66667ZM2.28889 3.66667L1.5 1"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3906 9.04688L11.5395 10.3591C11.6451 10.4802 11.8351 10.4702 11.9284 10.3413L14.2617 7.11133"
        stroke="#F3F3F3"
        fill={color ? color : "#9E9E9E"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UnLockIcon: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill={color ? color : "9E9E9E"}
    >
      <path
        d="M18.1641 1C15.4041 1 13.1641 3.24 13.1641 6V8H4.16406C3.63363 8 3.12492 8.21071 2.74985 8.58579C2.37478 8.96086 2.16406 9.46957 2.16406 10V20C2.16406 20.5304 2.37478 21.0391 2.74985 21.4142C3.12492 21.7893 3.63363 22 4.16406 22H16.1641C17.2741 22 18.1641 21.11 18.1641 20V10C18.1641 9.46957 17.9533 8.96086 17.5783 8.58579C17.2032 8.21071 16.6945 8 16.1641 8H15.1641V6C15.1641 4.34 16.5041 3 18.1641 3C19.8241 3 21.1641 4.34 21.1641 6V8H23.1641V6C23.1641 3.24 20.9241 1 18.1641 1ZM10.1641 13C10.6945 13 11.2032 13.2107 11.5783 13.5858C11.9533 13.9609 12.1641 14.4696 12.1641 15C12.1641 16.11 11.2741 17 10.1641 17C9.63363 17 9.12492 16.7893 8.74985 16.4142C8.37478 16.0391 8.16406 15.5304 8.16406 15C8.16406 14.4696 8.37478 13.9609 8.74985 13.5858C9.12492 13.2107 9.63363 13 10.1641 13Z"
        fill={color ? color : "9E9E9E"}
      />
    </svg>
  );
};

export const ImageStockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_4112_41701)" filter="url(#filter0_d_4112_41701)">
        <path
          d="M9.43812 8.67187C9.43812 9.0255 9.29854 9.36463 9.05008 9.61468C8.80161 9.86473 8.46463 10.0052 8.11325 10.0052H1.48893C1.13755 10.0052 0.800567 9.86473 0.552107 9.61468C0.303646 9.36463 0.164063 9.0255 0.164063 8.67187V3.33854C0.164062 2.98515 0.303464 2.64621 0.551638 2.3962C0.799812 2.14619 1.13646 2.00556 1.4876 2.00521C1.4876 1.65159 1.62719 1.31245 1.87565 1.0624C2.12411 0.812351 2.46109 0.671875 2.81247 0.671875H9.43679C9.78817 0.671875 10.1252 0.812351 10.3736 1.0624C10.6221 1.31245 10.7617 1.65159 10.7617 2.00521V7.33854C10.7617 7.69193 10.6223 8.03087 10.3741 8.28088C10.1259 8.53089 9.78927 8.67152 9.43812 8.67187ZM9.43679 1.33854H2.81247C2.63678 1.33854 2.46829 1.40878 2.34406 1.5338C2.21983 1.65883 2.15004 1.8284 2.15004 2.00521H8.11325C8.46463 2.00521 8.80161 2.14568 9.05008 2.39573C9.29854 2.64578 9.43812 2.98492 9.43812 3.33854V8.00521C9.61358 8.00485 9.78173 7.93446 9.90567 7.80947C10.0296 7.68449 10.0992 7.51512 10.0992 7.33854V2.00521C10.0992 1.8284 10.0294 1.65883 9.9052 1.5338C9.78097 1.40878 9.61248 1.33854 9.43679 1.33854ZM1.48893 2.67187C1.31324 2.67187 1.14475 2.74211 1.02052 2.86714C0.896287 2.99216 0.826495 3.16173 0.826495 3.33854V8.67187L2.57929 7.10254C2.63343 7.04825 2.70457 7.01447 2.78063 7.00694C2.85669 6.99941 2.933 7.01858 2.99662 7.06121L4.7587 8.24321L7.21632 5.76987C7.26544 5.72039 7.32879 5.68771 7.39738 5.67646C7.46598 5.66522 7.53636 5.67597 7.59854 5.70721L8.77569 7.00521V3.33854C8.77569 3.16173 8.70589 2.99216 8.58166 2.86714C8.45743 2.74211 8.28894 2.67187 8.11325 2.67187H1.48893Z"
          fill="#F3F3F3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4112_41701"
          x="0.164062"
          y="0.00488281"
          width="14.5977"
          height="14.667"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4112_41701"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4112_41701"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_4112_41701">
          <rect
            width="10.5989"
            height="10.6667"
            fill="white"
            transform="translate(0.164062 0.00488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TextMessageIcon = ({
  color = "#7262C2",
  width = "18",
  height = "18",
}: {
  color?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3 3H15V12H3.8775L3 12.8775V3ZM3 1.5C2.175 1.5 1.5075 2.175 1.5075 3L1.5 16.5L4.5 13.5H15C15.825 13.5 16.5 12.825 16.5 12V3C16.5 2.175 15.825 1.5 15 1.5H3ZM4.5 9H13.5V10.5H4.5V9ZM4.5 6.75H13.5V8.25H4.5V6.75ZM4.5 4.5H13.5V6H4.5V4.5Z"
        fill={color}
      />
    </svg>
  );
};

export const VideoCallIcon = ({
  color = "#7262C2",
  width = "18",
  height = "18",
}: {
  color?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M16.1475 5.3625C16.0335 5.29667 15.9042 5.26202 15.7725 5.26202C15.6408 5.26202 15.5115 5.29667 15.3975 5.3625L12.75 6.6675C12.7286 6.08518 12.4822 5.53386 12.0625 5.12958C11.6429 4.7253 11.0827 4.49961 10.5 4.5H3.75C3.15326 4.5 2.58097 4.73705 2.15901 5.15901C1.73705 5.58097 1.5 6.15326 1.5 6.75V11.25C1.5 11.8467 1.73705 12.419 2.15901 12.841C2.58097 13.2629 3.15326 13.5 3.75 13.5H10.5C11.0827 13.5004 11.6429 13.2747 12.0625 12.8704C12.4822 12.4661 12.7286 11.9148 12.75 11.3325L15.42 12.6675C15.5222 12.7199 15.6351 12.7481 15.75 12.75C15.8904 12.7505 16.0281 12.7115 16.1475 12.6375C16.2556 12.5699 16.3447 12.476 16.4063 12.3644C16.468 12.2529 16.5003 12.1275 16.5 12V6C16.5003 5.87254 16.468 5.74712 16.4063 5.63558C16.3447 5.52404 16.2556 5.43005 16.1475 5.3625ZM11.25 11.25C11.25 11.4489 11.171 11.6397 11.0303 11.7803C10.8897 11.921 10.6989 12 10.5 12H3.75C3.55109 12 3.36032 11.921 3.21967 11.7803C3.07902 11.6397 3 11.4489 3 11.25V6.75C3 6.55109 3.07902 6.36032 3.21967 6.21967C3.36032 6.07902 3.55109 6 3.75 6H10.5C10.6989 6 10.8897 6.07902 11.0303 6.21967C11.171 6.36032 11.25 6.55109 11.25 6.75V11.25ZM15 10.785L12.75 9.66V8.34L15 7.215V10.785Z"
        fill={color}
      />
    </svg>
  );
};

export const AudioCallIcon = ({
  color = "#7262C2",
  width = "18",
  height = "18",
}: {
  color?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.34163 3.82577C8.23067 3.52368 8.00832 3.27551 7.7202 3.13214C7.43208 2.98878 7.10002 2.96109 6.79213 3.05477C5.33263 3.50477 4.31263 4.75727 4.53163 6.20627C4.77808 7.8141 5.32294 9.36168 6.13813 10.7693C6.94582 12.1731 8.00496 13.4163 9.26263 14.4368C10.3936 15.3518 11.9806 15.0998 13.0996 14.0498C13.335 13.8289 13.4778 13.5269 13.4993 13.2048C13.5207 12.8827 13.4192 12.5644 13.2151 12.3143L12.4141 11.3348C12.2537 11.1378 12.0378 10.9936 11.7944 10.9208C11.551 10.8481 11.2913 10.8502 11.0491 10.9268L9.20113 11.5118L8.87863 11.1788C8.47246 10.7572 8.11704 10.2895 7.81963 9.78527C7.5316 9.275 7.30694 8.73148 7.15063 8.16677L7.02613 7.72427L8.45113 6.41177C8.63968 6.23752 8.77194 6.01098 8.83099 5.76113C8.89005 5.51128 8.87321 5.24949 8.78263 5.00927L8.34163 3.82577ZM6.35113 1.62077C7.02486 1.41464 7.75192 1.47396 8.38332 1.7866C9.01471 2.09923 9.50265 2.64149 9.74713 3.30227L10.1866 4.48427C10.3811 5.00348 10.4165 5.56886 10.2883 6.10827C10.16 6.64768 9.87398 7.13664 9.46663 7.51277L8.73163 8.18927C8.82613 8.45027 8.95363 8.74877 9.11863 9.03827C9.28363 9.32327 9.47563 9.58277 9.65113 9.79427L10.5961 9.49427C11.1245 9.32747 11.6907 9.32308 12.2215 9.48166C12.7524 9.64025 13.2234 9.95451 13.5736 10.3838L14.3746 11.3633C14.8198 11.9076 15.0417 12.6007 14.9955 13.3024C14.9492 14.004 14.6383 14.662 14.1256 15.1433C12.6346 16.5428 10.2001 17.1233 8.32063 15.6023C6.92 14.4663 5.74036 13.0822 4.84063 11.5193C3.93103 9.94937 3.32308 8.22319 3.04813 6.42977C2.68813 4.04027 4.40263 2.22077 6.35113 1.62227"
        fill={color}
      />
    </svg>
  );
};

interface TickMarkIconProps {
  color?: string;
}
export const TickMarkIcon: React.FC<TickMarkIconProps> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM7.84533 10.4267L11.1787 6.42667L10.1547 5.57333L7.288 9.01267L5.80467 7.52867L4.862 8.47133L6.862 10.4713L7.378 10.9873L7.84533 10.4267Z"
        fill={color ? color : "#7262C2"}
      />
    </svg>
  );
};

export const CancelRedIcon: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = ({ color, width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "12"}
      height={height ? height : "12"}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <line
        x1="10.4919"
        y1="1.99284"
        x2="2.00658"
        y2="10.4781"
        stroke={color ? color : "#B71C1C"}
        stroke-width="1.8"
      />
      <line
        x1="2.00749"
        y1="1.49153"
        x2="10.4928"
        y2="9.97682"
        stroke={color ? color : "#B71C1C"}
        stroke-width="1.8"
      />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <line
        x1="20.3493"
        y1="3.35026"
        x2="3.37872"
        y2="20.3208"
        stroke="#212121"
        stroke-width="1.8"
      />
      <line
        x1="3.38054"
        y1="3.6202"
        x2="20.3511"
        y2="20.5908"
        stroke="#212121"
        stroke-width="1.8"
      />
    </svg>
  );
};

export const ArrowForwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_4873_28037)">
        <path
          d="M10.5 12.6667L15.1667 8.00004L10.5 3.33333"
          stroke="#7262C2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4873_28037">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ForwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 19.0002L22.0001 12.0002L15 5.00012"
        stroke="#7262C2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FullScreenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.23508 1.33337V2.01965C6.23508 2.50984 5.84292 2.80396 5.45076 2.80396H3.09783L2.90175 2.902V5.45101C2.90175 5.9412 2.5096 6.23532 2.11744 6.23532H1.33313V3.09807C1.33313 2.902 1.33313 2.60788 1.43117 2.4118C1.52921 2.21572 1.62725 2.01965 1.82332 1.82357C2.0194 1.62749 2.11744 1.52945 2.41156 1.43141C2.60764 1.43141 2.90175 1.33337 3.09783 1.33337H6.23508Z"
        fill="white"
      />
      <path
        d="M6.23508 13.9804V14.6667H3.09783C2.90175 14.6667 2.60764 14.6667 2.41156 14.5687C2.21548 14.4706 2.0194 14.3726 1.82332 14.1765C1.62725 13.9804 1.52921 13.8824 1.43117 13.5883C1.33313 13.3922 1.33313 13.1961 1.33313 12.902V9.76476H2.0194C2.5096 9.76476 2.80371 10.1569 2.80371 10.5491V12.902L2.90175 13.0981C2.99979 13.0981 3.09783 13.0981 3.09783 13.0981H5.45076C5.94096 13.0981 6.23508 13.4902 6.23508 13.9804Z"
        fill="white"
      />
      <path
        d="M14.6664 3.09807V6.23532H13.9802C13.49 6.23532 13.1958 5.84316 13.1958 5.45101V3.09807L13.0978 2.902H10.4508C9.96056 2.902 9.66644 2.50984 9.66644 2.11769V1.33337H12.9017C12.9998 1.33337 13.0978 1.33337 13.1958 1.33337C13.1958 1.33337 13.1958 1.33337 13.2939 1.33337C13.3919 1.33337 13.49 1.33337 13.588 1.43141C13.7841 1.52945 13.9802 1.62749 14.1762 1.82357C14.3723 2.01965 14.4704 2.11769 14.5684 2.4118V2.50984C14.5684 2.70592 14.6664 2.902 14.6664 3.09807Z"
        fill="white"
      />
      <path
        d="M14.6664 9.76476V12.902C14.6664 13 14.6664 13.0981 14.6664 13.1961C14.6664 13.2942 14.6664 13.2942 14.5684 13.3922C14.5684 13.4902 14.5684 13.4902 14.5684 13.5883C14.4703 13.7844 14.3723 13.9804 14.1762 14.1765C13.9801 14.3726 13.8821 14.4706 13.588 14.5687C13.3919 14.6667 13.0978 14.6667 12.9017 14.6667H9.76447V13.9804C9.76447 13.4902 10.1566 13.1961 10.5488 13.1961H12.9017C12.9017 13.1961 12.9017 13.1961 12.9998 13.1961C12.9998 13.1961 13.0978 13.1961 13.0978 13.0981L13.1958 12.902V10.5491C13.1958 10.0589 13.588 9.76476 13.9801 9.76476H14.6664Z"
        fill="white"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="5"
        stroke="#7262C2"
        stroke-width="1.8"
      />
      <line
        x1="12.0992"
        y1="6.9"
        x2="12.0992"
        y2="17.1"
        stroke="#7262C2"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <line
        x1="6.9"
        y1="11.8"
        x2="17.1"
        y2="11.8"
        stroke="#7262C2"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const ProcessingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 17C12.2833 17 12.521 16.904 12.713 16.712C12.905 16.52 13.0007 16.2827 13 16C12.9993 15.7173 12.9033 15.48 12.712 15.288C12.5207 15.096 12.2833 15 12 15C11.7167 15 11.4793 15.096 11.288 15.288C11.0967 15.48 11.0007 15.7173 11 16C10.9993 16.2827 11.0953 16.5203 11.288 16.713C11.4807 16.9057 11.718 17.0013 12 17ZM11 13H13V7H11V13ZM8.25 21L3 15.75V8.25L8.25 3H15.75L21 8.25V15.75L15.75 21H8.25Z"
        fill="#C15700"
      />
    </svg>
  );
};

export const VideoCallCameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13 3.5H11.2675L10.4156 2.2225C10.37 2.15409 10.3082 2.098 10.2357 2.05919C10.1632 2.02038 10.0822 2.00005 10 2H6C5.91777 2.00005 5.83682 2.02038 5.76432 2.05919C5.69182 2.098 5.63001 2.15409 5.58437 2.2225L4.73187 3.5H3C2.60218 3.5 2.22064 3.65804 1.93934 3.93934C1.65804 4.22064 1.5 4.60218 1.5 5V12C1.5 12.3978 1.65804 12.7794 1.93934 13.0607C2.22064 13.342 2.60218 13.5 3 13.5H13C13.3978 13.5 13.7794 13.342 14.0607 13.0607C14.342 12.7794 14.5 12.3978 14.5 12V5C14.5 4.60218 14.342 4.22064 14.0607 3.93934C13.7794 3.65804 13.3978 3.5 13 3.5ZM10.25 8.25C10.25 8.69501 10.118 9.13002 9.87081 9.50003C9.62357 9.87004 9.27217 10.1584 8.86104 10.3287C8.4499 10.499 7.9975 10.5436 7.56105 10.4568C7.12459 10.37 6.72368 10.1557 6.40901 9.84099C6.09434 9.52632 5.88005 9.12541 5.79323 8.68895C5.70642 8.2525 5.75097 7.8001 5.92127 7.38896C6.09157 6.97783 6.37996 6.62643 6.74997 6.37919C7.11998 6.13196 7.55499 6 8 6C8.59674 6 9.16903 6.23705 9.59099 6.65901C10.0129 7.08097 10.25 7.65326 10.25 8.25Z"
        fill="#7262C2"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="15"
      viewBox="0 0 4 15"
      fill="none"
    >
      <circle
        cx="2"
        cy="13"
        r="1.5"
        transform="rotate(-90 2 13)"
        fill="#212121"
      />
      <circle
        cx="2"
        cy="7.5"
        r="1.5"
        transform="rotate(-90 2 7.5)"
        fill="#212121"
      />
      <circle
        cx="2"
        cy="2"
        r="1.5"
        transform="rotate(-90 2 2)"
        fill="#212121"
      />
    </svg>
  );
};

export const GreenTick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
        fill="#2E7D32"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6654 2.66634H11.332V1.99967C11.332 1.82286 11.2618 1.65329 11.1368 1.52827C11.0117 1.40325 10.8422 1.33301 10.6654 1.33301C10.4886 1.33301 10.319 1.40325 10.194 1.52827C10.0689 1.65329 9.9987 1.82286 9.9987 1.99967V2.66634H5.9987V1.99967C5.9987 1.82286 5.92846 1.65329 5.80344 1.52827C5.67841 1.40325 5.50884 1.33301 5.33203 1.33301C5.15522 1.33301 4.98565 1.40325 4.86063 1.52827C4.7356 1.65329 4.66536 1.82286 4.66536 1.99967V2.66634H3.33203C2.8016 2.66634 2.29289 2.87705 1.91782 3.25213C1.54274 3.6272 1.33203 4.13591 1.33203 4.66634V12.6663C1.33203 13.1968 1.54274 13.7055 1.91782 14.0806C2.29289 14.4556 2.8016 14.6663 3.33203 14.6663H12.6654C13.1958 14.6663 13.7045 14.4556 14.0796 14.0806C14.4547 13.7055 14.6654 13.1968 14.6654 12.6663V4.66634C14.6654 4.13591 14.4547 3.6272 14.0796 3.25213C13.7045 2.87705 13.1958 2.66634 12.6654 2.66634ZM13.332 12.6663C13.332 12.8432 13.2618 13.0127 13.1368 13.1377C13.0117 13.2628 12.8422 13.333 12.6654 13.333H3.33203C3.15522 13.333 2.98565 13.2628 2.86063 13.1377C2.7356 13.0127 2.66536 12.8432 2.66536 12.6663V7.99967H13.332V12.6663ZM13.332 6.66634H2.66536V4.66634C2.66536 4.48953 2.7356 4.31996 2.86063 4.19494C2.98565 4.06991 3.15522 3.99967 3.33203 3.99967H4.66536V4.66634C4.66536 4.84315 4.7356 5.01272 4.86063 5.13775C4.98565 5.26277 5.15522 5.33301 5.33203 5.33301C5.50884 5.33301 5.67841 5.26277 5.80344 5.13775C5.92846 5.01272 5.9987 4.84315 5.9987 4.66634V3.99967H9.9987V4.66634C9.9987 4.84315 10.0689 5.01272 10.194 5.13775C10.319 5.26277 10.4886 5.33301 10.6654 5.33301C10.8422 5.33301 11.0117 5.26277 11.1368 5.13775C11.2618 5.01272 11.332 4.84315 11.332 4.66634V3.99967H12.6654C12.8422 3.99967 13.0117 4.06991 13.1368 4.19494C13.2618 4.31996 13.332 4.48953 13.332 4.66634V6.66634Z"
        fill="#7262C2"
      />
    </svg>
  );
};

export const TickIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 12C6.78793 12 7.56815 11.8448 8.2961 11.5433C9.02405 11.2417 9.68549 10.7998 10.2426 10.2426C10.7998 9.68549 11.2417 9.02405 11.5433 8.2961C11.8448 7.56815 12 6.78793 12 6C12 5.21207 11.8448 4.43185 11.5433 3.7039C11.2417 2.97595 10.7998 2.31451 10.2426 1.75736C9.68549 1.20021 9.02405 0.758251 8.2961 0.456723C7.56815 0.155195 6.78793 -1.17411e-08 6 0C4.4087 2.37122e-08 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.84533 8.42667L9.17867 4.42667L8.15467 3.57333L5.288 7.01267L3.80467 5.52867L2.862 6.47133L4.862 8.47133L5.378 8.98733L5.84533 8.42667Z"
        fill="#7262C2"
      />
    </svg>
  );
};

export const AddSlotsIcon: React.FC<{ color?: string; fillColor?: string }> = ({
  color = "#9E9E9E",
  fillColor = "#7262C2",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <rect
        x="2"
        y="2.625"
        width="20"
        height="20"
        rx="10"
        fill={fillColor}
        stroke={color}
        stroke-width="1.8"
      />
      <line
        x1="12.1002"
        y1="7.525"
        x2="12.1002"
        y2="17.725"
        stroke={color}
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <line
        x1="6.9"
        y1="12.4252"
        x2="17.1"
        y2="12.4252"
        stroke={color}
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const RemoveSlotsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.50488 11.4955L8.00022 8.00022L11.4955 11.4955M11.4955 4.50488L7.99955 8.00022L4.50488 4.50488"
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DropDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M5.60011 8.02513L7.60011 10.0251C7.80011 10.2251 8.13344 10.2251 8.40011 10.0251L10.4001 8.02513C10.7334 7.6918 10.5334 7.0918 10.0001 7.0918H6.00011C5.53344 7.0918 5.26677 7.6918 5.60011 8.02513Z"
        fill="#9E9E9E"
      />
    </svg>
  );
};
export const CloutCoinIcon = () => {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83789 10.2812H10.3945C10.3672 10.7005 10.2943 11.097 10.1758 11.4707C10.0664 11.8353 9.9069 12.1816 9.69727 12.5098C9.49674 12.8379 9.25521 13.1296 8.97266 13.3848C8.6901 13.6309 8.36654 13.8451 8.00195 14.0273C7.63737 14.2096 7.23633 14.3464 6.79883 14.4375C6.37044 14.5286 5.90104 14.5742 5.39062 14.5742C4.98958 14.5742 4.60677 14.5378 4.24219 14.4648C3.88672 14.401 3.55404 14.3008 3.24414 14.1641C2.92513 14.0273 2.62891 13.8587 2.35547 13.6582C2.09115 13.4577 1.84505 13.2298 1.61719 12.9746C1.39844 12.7103 1.20247 12.4232 1.0293 12.1133C0.85612 11.7943 0.714844 11.4525 0.605469 11.0879C0.486979 10.7233 0.395833 10.3359 0.332031 9.92578C0.277344 9.51562 0.25 9.08268 0.25 8.62695V7.75195C0.25 7.29622 0.277344 6.86328 0.332031 6.45312C0.395833 6.04297 0.486979 5.6556 0.605469 5.29102C0.733073 4.91732 0.883464 4.57552 1.05664 4.26562C1.22982 3.94661 1.43034 3.65951 1.6582 3.4043C1.87695 3.13997 2.12305 2.90755 2.39648 2.70703C2.66992 2.50651 2.96615 2.33789 3.28516 2.20117C3.51302 2.10091 3.79102 2.01432 4.11914 1.94141C4.45638 1.85938 4.625 1.81836 4.625 1.81836V0.875H6.15625V1.81836C6.51172 1.8457 6.8444 1.90495 7.1543 1.99609C7.46419 2.08724 7.75586 2.20573 8.0293 2.35156C8.38477 2.53385 8.69922 2.75716 8.97266 3.02148C9.25521 3.27669 9.49674 3.57292 9.69727 3.91016C9.88867 4.23828 10.0436 4.58919 10.1621 4.96289C10.2897 5.33659 10.3717 5.73763 10.4082 6.16602H7.85156C7.83333 5.91081 7.79688 5.67839 7.74219 5.46875C7.69661 5.25 7.63281 5.05404 7.55078 4.88086C7.45964 4.70768 7.35026 4.55729 7.22266 4.42969C7.09505 4.29297 6.94466 4.17904 6.77148 4.08789C6.59831 3.99674 6.39779 3.92839 6.16992 3.88281C5.94206 3.83724 5.68685 3.81445 5.4043 3.81445C5.18555 3.81445 4.98047 3.83724 4.78906 3.88281C4.60677 3.91927 4.43815 3.97852 4.2832 4.06055C4.11914 4.14258 3.96875 4.24284 3.83203 4.36133C3.70443 4.47982 3.58594 4.62109 3.47656 4.78516C3.36719 4.94922 3.27148 5.13607 3.18945 5.3457C3.11654 5.54622 3.05273 5.76953 2.99805 6.01562C2.94336 6.26172 2.90234 6.5306 2.875 6.82227C2.84766 7.10482 2.83398 7.41016 2.83398 7.73828V8.62695C2.83398 8.94596 2.84766 9.24674 2.875 9.5293C2.90234 9.81185 2.9388 10.0762 2.98438 10.3223C3.02995 10.5592 3.08919 10.7826 3.16211 10.9922C3.24414 11.1927 3.33073 11.3796 3.42188 11.5527C3.53125 11.7168 3.64974 11.8626 3.77734 11.9902C3.90495 12.1178 4.05078 12.2227 4.21484 12.3047C4.37891 12.3867 4.55664 12.4505 4.74805 12.4961C4.94857 12.5326 5.16276 12.5508 5.39062 12.5508C5.65495 12.5508 5.89648 12.5326 6.11523 12.4961C6.33398 12.4505 6.52995 12.3822 6.70312 12.291C6.88542 12.209 7.04036 12.1042 7.16797 11.9766C7.30469 11.849 7.41862 11.7031 7.50977 11.5391C7.60091 11.3659 7.67383 11.1745 7.72852 10.9648C7.7832 10.7552 7.81966 10.5273 7.83789 10.2812Z"
        fill="#212121"
      />
    </svg>
  );
};
export const ClockSvgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99967 1.33301C11.6817 1.33301 14.6663 4.31767 14.6663 7.99967C14.6663 11.6817 11.6817 14.6663 7.99967 14.6663C4.31767 14.6663 1.33301 11.6817 1.33301 7.99967C1.33301 4.31767 4.31767 1.33301 7.99967 1.33301ZM7.99967 2.66634C6.58519 2.66634 5.22863 3.22824 4.22844 4.22844C3.22824 5.22863 2.66634 6.58519 2.66634 7.99967C2.66634 9.41416 3.22824 10.7707 4.22844 11.7709C5.22863 12.7711 6.58519 13.333 7.99967 13.333C9.41416 13.333 10.7707 12.7711 11.7709 11.7709C12.7711 10.7707 13.333 9.41416 13.333 7.99967C13.333 6.58519 12.7711 5.22863 11.7709 4.22844C10.7707 3.22824 9.41416 2.66634 7.99967 2.66634ZM7.99967 3.99967C8.16296 3.9997 8.32057 4.05965 8.44259 4.16815C8.56461 4.27666 8.64257 4.42617 8.66167 4.58834L8.66634 4.66634V7.72367L10.471 9.52834C10.5906 9.64831 10.66 9.8093 10.6652 9.9786C10.6703 10.1479 10.6109 10.3128 10.4988 10.4399C10.3868 10.5669 10.2306 10.6465 10.062 10.6626C9.89341 10.6787 9.725 10.6299 9.59101 10.5263L9.52834 10.471L7.52834 8.47101C7.42473 8.36731 7.35818 8.23234 7.33901 8.08701L7.33301 7.99967V4.66634C7.33301 4.48953 7.40325 4.31996 7.52827 4.19494C7.65329 4.06991 7.82286 3.99967 7.99967 3.99967Z"
        fill="#212121"
      />
    </svg>
  );
};
export const WarningSvgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9 12.75C9.2125 12.75 9.39075 12.678 9.53475 12.534C9.67875 12.39 9.7505 12.212 9.75 12C9.7495 11.788 9.6775 11.61 9.534 11.466C9.3905 11.322 9.2125 11.25 9 11.25C8.7875 11.25 8.6095 11.322 8.466 11.466C8.3225 11.61 8.2505 11.788 8.25 12C8.2495 12.212 8.3215 12.3902 8.466 12.5347C8.6105 12.6792 8.7885 12.751 9 12.75ZM8.25 9.75H9.75V5.25H8.25V9.75ZM6.1875 15.75L2.25 11.8125V6.1875L6.1875 2.25H11.8125L15.75 6.1875V11.8125L11.8125 15.75H6.1875Z"
        fill="#C15700"
      />
    </svg>
  );
};

export const ReportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 17C12.2833 17 12.521 16.904 12.713 16.712C12.905 16.52 13.0007 16.2827 13 16C12.9993 15.7173 12.9033 15.48 12.712 15.288C12.5207 15.096 12.2833 15 12 15C11.7167 15 11.4793 15.096 11.288 15.288C11.0967 15.48 11.0007 15.7173 11 16C10.9993 16.2827 11.0953 16.5203 11.288 16.713C11.4807 16.9057 11.718 17.0013 12 17ZM11 13H13V7H11V13ZM8.25 21L3 15.75V8.25L8.25 3H15.75L21 8.25V15.75L15.75 21H8.25Z"
        fill="#212121"
      />
    </svg>
  );
};

export const BlockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.59177 15.5031 3.99639 13.7769 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.4082 8.49686 20.0036 10.2231 20 12C20 16.42 16.42 20 12 20Z"
        fill="#212121"
      />
    </svg>
  );
};

export const GreenCheckMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052ZM11.4955 6.05924C11.4954 6.23608 11.4251 6.40566 11.3 6.53067L7.576 10.2547C7.5079 10.3228 7.42704 10.3768 7.33805 10.4137C7.24905 10.4506 7.15367 10.4696 7.05733 10.4696C6.961 10.4696 6.86561 10.4506 6.77662 10.4137C6.68762 10.3768 6.60677 10.3228 6.53867 10.2547L4.7 8.416C4.57499 8.29091 4.5048 8.12128 4.50487 7.94443C4.50493 7.76758 4.57524 7.59801 4.70033 7.473C4.82543 7.34799 4.99506 7.2778 5.1719 7.27787C5.25947 7.2779 5.34617 7.29517 5.42706 7.32871C5.50795 7.36225 5.58144 7.41139 5.64333 7.47333L7.05733 8.88733L10.3573 5.58733C10.4824 5.46233 10.6521 5.39214 10.8289 5.3922C11.0057 5.39226 11.1753 5.46257 11.3003 5.58767C11.4253 5.71276 11.4955 5.88239 11.4955 6.05924Z"
        fill="#2E7D32"
      />
    </svg>
  );
};

export const CancelRescheduleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <line
        x1="13.779"
        y1="2.44597"
        x2="2.46527"
        y2="13.7597"
        stroke="#B71C1C"
        stroke-width="1.8"
      />
      <line
        x1="2.4655"
        y1="2.20149"
        x2="13.7792"
        y2="13.5152"
        stroke="#B71C1C"
        stroke-width="1.8"
      />
    </svg>
  );
};

export const SpeakerIcon = ({ color = "#F3F3F3" }: { color?: string }) => {
  return (
    <svg
      width="48"
      height="36"
      viewBox="0 0 48 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.689 0.207376C23.08 0.386929 23.4113 0.674815 23.6436 1.03691C23.876 1.39901 23.9997 1.82014 24 2.25038V33.7504C23.999 34.1802 23.8751 34.6009 23.6429 34.9626C23.4106 35.3243 23.0797 35.612 22.6893 35.7918C22.2988 35.9716 21.865 36.0359 21.4392 35.9772C21.0134 35.9185 20.6132 35.7391 20.286 35.4604L10.416 27.0004H5.25C3.85761 27.0004 2.52226 26.4473 1.53769 25.4627C0.553123 24.4781 0 23.1428 0 21.7504L0 14.2504C0 11.3524 2.352 9.00038 5.25 9.00038H10.419L20.286 0.540376C20.6129 0.261085 21.0129 0.0812909 21.4388 0.0222756C21.8646 -0.0367396 22.2985 0.0274949 22.689 0.207376ZM19.5 7.14038L12.714 12.9574C12.3065 13.3073 11.7872 13.4999 11.25 13.5004H5.25C5.05109 13.5004 4.86032 13.5794 4.71967 13.72C4.57902 13.8607 4.5 14.0515 4.5 14.2504V21.7504C4.5 22.1644 4.836 22.5004 5.25 22.5004H11.25C11.787 22.5004 12.306 22.6924 12.714 23.0404L19.5 28.8604V7.14038ZM37.788 1.02638C38.2099 0.605025 38.7817 0.368356 39.378 0.368356C39.9743 0.368356 40.5461 0.605025 40.968 1.02638C43.1967 3.255 44.9647 5.90079 46.1709 8.81269C47.3771 11.7246 47.9979 14.8455 47.9979 17.9974C47.9979 21.1492 47.3771 24.2702 46.1709 27.1821C44.9647 30.094 43.1967 32.7398 40.968 34.9684C40.5416 35.3663 39.9773 35.5831 39.3941 35.573C38.8109 35.5629 38.2544 35.3268 37.842 34.9144C37.4296 34.5019 37.1934 33.9455 37.1834 33.3623C37.1733 32.7791 37.3901 32.2148 37.788 31.7884C39.599 29.9776 41.0356 27.8278 42.0157 25.4618C42.9959 23.0958 43.5003 20.5599 43.5003 17.9989C43.5003 15.4379 42.9959 12.902 42.0157 10.536C41.0356 8.16993 39.599 6.02015 37.788 4.20938C37.3666 3.7875 37.13 3.21563 37.13 2.61938C37.13 2.02312 37.3666 1.44825 37.788 1.02638ZM34.608 7.38938L34.605 7.39238C37.4171 10.2053 38.9968 14.0199 38.9968 17.9974C38.9968 21.9748 37.4171 25.7895 34.605 28.6024C34.33 28.8986 33.9802 29.1151 33.5924 29.2291C33.2047 29.3432 32.7934 29.3505 32.4018 29.2504C32.0102 29.1503 31.6529 28.9464 31.3675 28.6602C31.0821 28.3741 30.8791 28.0162 30.78 27.6244C30.6801 27.2332 30.6872 26.8224 30.8007 26.435C30.9142 26.0476 31.1298 25.6978 31.425 25.4224C32.4001 24.4473 33.1736 23.2898 33.7014 22.0158C34.2291 20.7418 34.5008 19.3763 34.5008 17.9974C34.5008 16.6184 34.2291 15.2529 33.7014 13.979C33.1736 12.705 32.4001 11.5474 31.425 10.5724C31.0029 10.1503 30.7658 9.57781 30.7658 8.98088C30.7658 8.38395 31.0029 7.81147 31.425 7.38938C31.8471 6.96728 32.4196 6.73016 33.0165 6.73016C33.6134 6.73016 34.1859 6.96728 34.608 7.38938Z"
        fill={color}
      />
    </svg>
  );
};

export const MuteIcon = ({ color = "#F3F3F3" }: { color?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.6 0L33 12.6V9C33 3.9 29.1 0 24 0C18.9 0 15 3.9 15 9V21C15 23.7 16.2 26.1 18 27.6L15.6 30C13.5 28.2 12 25.5 12 22.5V15C10.2 15 9 16.2 9 18V22.5C9 26.4 10.8 29.7 13.5 32.1L0 45.9V48H2.1L48 1.8V0H45.6ZM37.5 15.3L36 16.8V22.5C36 28.2 30.6 33 24.6 33H23.4C22.5 33 21.6 32.7 20.7 32.7L18 34.8C18.9 35.1 19.8 35.4 21 35.7V42C12 42 13.5 48 13.5 48H34.5C34.5 48 36 42 27 42V35.7C33.6 34.5 39 29.1 39 22.5V18C39 16.8 38.4 15.9 37.5 15.3Z"
        fill={color}
      />
      <path
        d="M32.9996 20.9998V19.7998L23.0996 29.9998H23.9996C29.0996 29.9998 32.9996 25.7998 32.9996 20.9998Z"
        fill={color}
      />
    </svg>
  );
};

export const EndIcon = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4 15C28.3333 15 32.2087 15.792 36.026 17.376C39.8433 18.96 43.2347 21.3347 46.2 24.5C46.6 24.9 46.8 25.3667 46.8 25.9C46.8 26.4333 46.6 26.9 46.2 27.3L41.6 31.8C41.2333 32.1667 40.808 32.3667 40.324 32.4C39.84 32.4333 39.3987 32.3 39 32L33.2 27.6C32.9333 27.4 32.7333 27.1667 32.6 26.9C32.4667 26.6333 32.4 26.3333 32.4 26V20.3C31.1333 19.9 29.8333 19.5833 28.5 19.35C27.1667 19.1167 25.8 19 24.4 19C23 19 21.6333 19.1167 20.3 19.35C18.9667 19.5833 17.6667 19.9 16.4 20.3V26C16.4 26.3333 16.3333 26.6333 16.2 26.9C16.0667 27.1667 15.8667 27.4 15.6 27.6L9.8 32C9.4 32.3 8.958 32.4333 8.474 32.4C7.99 32.3667 7.56533 32.1667 7.2 31.8L2.6 27.3C2.2 26.9 2 26.4333 2 25.9C2 25.3667 2.2 24.9 2.6 24.5C5.53333 21.3333 8.91667 18.9587 12.75 17.376C16.5833 15.7933 20.4667 15.0013 24.4 15Z"
        fill="#F3F3F3"
      />
    </svg>
  )
}

export const ForwardArrowIcon=()=>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M15 19.0002L22.0001 12.0001L15 5.00006" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
};
